import React from 'react';
import { Link } from 'react-router-dom'
import {Row,Col, Grid} from 'react-bootstrap'

export default class ThankYou extends React.Component{
  render() {
      let today = new Date().getFullYear()
      return(<div className="thankyou-page">
                  <Grid>
                    <Row>
                      <Col md={12}>
                          <div className="thankyou-logo">
                              <Link to="">
                                <img src="/images/logo-icon.png" alt="logo" />
                              </Link>
                          </div>
                          <div className="display-flex-align">
                            <div className="margin-auto">
                                <h1>Thankyou</h1>
                                <h2>We will be in touch soon!</h2>
                            </div>
                          </div>
                          <div className="copyright-footer">
                              <p>&copy; {today.toString()} Dokkit All rights reserved.</p>
                          </div>
                      </Col>
                    </Row>
                  </Grid>
             </div>    
      )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Pages/ThankYou.js